import {BaseRequestHandler} from "../requestHandler/BaseRequestHandler";

export class WarehouseFactory {
  public static async getUtilizationMessage(shopId: number): Promise<string | undefined> {
    return await BaseRequestHandler.performRequest<string | undefined>(
      "GET",
      `/shop/${shopId}/warehouse/utilization-message`,
    );
  }
}
